import { ProbabilitiesTable } from "../Inspect/ProbabilitiesTable";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample780099() {
  const llmPredictions = {
    s: 0.678,
    m: 0.192,
    l: 0.074,
    " ": 0.014,
    t: 0.012,
  };
  const circuitPredictions = {
    s: 0.48,
    m: 0.24,
    " ": 0.2,
    l: 0.04,
    r: 0.04,
  };
  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="780099" />
        <span> - </span>
        <SampleQuote text="unto whom" targetIdx={7} />
      </h4>
      <p>
        For this sample, the 6-layer GPT-2 model predicts either an “s” or “m” as the next token in
        the sequence. Collectively, the features in the last SAE layer (
        <FeatureAnchor modelId="baby-v1" sampleId="780099" featureKey="0.6.811" compact />
        ,&nbsp;
        <FeatureAnchor modelId="baby-v1" sampleId="780099" featureKey="0.6.3610" compact />,
        and&nbsp;
        <FeatureAnchor modelId="baby-v1" sampleId="780099" featureKey="0.6.4434" compact />) are
        most strongly triggered by the “o” in words like “whom” or “whose” when following
        prepositions like “in” or “to”. Among the top samples that activate these features, 48%
        include “whose” and 24% include “whom”. Such analysis, which the app automates, produces a
        prediction that aligns with the LLM’s output.
      </p>
      <div className="figures">
        <figure>
          <figcaption>LLM Prediction</figcaption>
          <ProbabilitiesTable probabilities={llmPredictions} limit={4} />
        </figure>
        <figure>
          <figcaption>Circuit Prediction</figcaption>
          <ProbabilitiesTable probabilities={circuitPredictions} limit={4} />
        </figure>
      </div>
    </section>
  );
}

export { Sample780099 };
